import { useNavigate } from 'react-router-dom'
import styles from './PreLandingPage.module.css'

const PreLandingPage = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.page}>
      <div className={styles.background}>
        <div className={styles.blob1} />
        <div className={styles.blob2} />
        <div className={styles.blob3} />
      </div>

      <div className="container">
        <div className={styles.content}>
          <img
            src="/boxos logo.png"
            alt="Box.OS - Rapid Results, Unbeatable"
            className={styles.logo}
          />
          <h1 className={styles.title}>Welcome to Box.OS.</h1>
          <p className={styles.subtitle}>Tell us what you're here for.</p>

          <div className={styles.options}>
            <button
              type="button"
              className={styles.optionCard}
              onClick={() => navigate('/boxos')}
            >
              <span className={styles.optionLabel}>I'm a developer</span>
              <span className={styles.optionDescription}>
                Try Box Editor, the AI-assisted development tool built for people who care about code quality.
              </span>
              <span className={styles.optionArrow}>→</span>
            </button>

            <button
              type="button"
              className={styles.optionCard}
              onClick={() => navigate('/solutions')}
            >
              <span className={styles.optionLabel}>I run a business</span>
              <span className={styles.optionDescription}>
                Get custom software and AI integration built around how your business actually works.
              </span>
              <span className={styles.optionArrow}>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PreLandingPage
